/** Готовые mock-скрины продукта (уже в phone-frame). */
export const LANDING_SCREEN = {
  ownerHome: "/landing/mock-owner-home.png",
  ownerCalendar: "/landing/mock-owner-calendar.png",
  ownerJournal: "/landing/mock-owner-journal.png",
  ownerClients: "/landing/mock-owner-clients.png",
  ownerFinance: "/landing/mock-owner-finance.png",
  clientHome: "/landing/mock-client-home.png",
  clientCalendar: "/landing/mock-client-calendar.png",
  clientChat: "/landing/mock-client-chat.png",
  clientProfile: "/landing/mock-client-profile.png",
  brandSplash: "/landing/mock-brand-splash.png",
  brandManage: "/landing/mock-brand-manage.png",
  brandClub: "/landing/mock-brand-club.png",
  /* aliases for older landing page refs */
  clientSchedule: "/landing/mock-client-calendar.png",
  trainerJournal: "/landing/mock-owner-journal.png",
  adminClients: "/landing/mock-owner-clients.png",
  staffOverview: "/landing/mock-owner-home.png",
  manageCalendar: "/landing/mock-owner-calendar.png",
  manageJournal: "/landing/mock-owner-journal.png",
  manageOverview: "/landing/mock-owner-home.png",
  manageFinance: "/landing/mock-owner-finance.png",
};
